import ComponentEmitter from 'tiny-emitter';

const Emitter = new ComponentEmitter;

export default Emitter;



// WEBPACK FOOTER //
// ./resources/assets/js/utilities/Emitter.js